import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { Bold, Card, CleanVehicleTaxPill } from './CleanTaxSavingsCard.styles';

type OwnProps = {
  className?: string;
};

const CleanTaxSavingsCard = ({ className = '' }: OwnProps) => {
  const { setEvTaxCreditModalOpen } = useContext(ModalContext);

  return (
    <Card className={className}>
      <CleanVehicleTaxPill>Clean Vehicle Tax Credit</CleanVehicleTaxPill>
      <span className="text-left text-blue-6 tl-body-s m:tl-body-m">
        This vehicle qualifies for a Previously-Owned Clean Vehicle Tax Credit
        up to a maximum amount of <Bold>$4,000</Bold>
      </span>
      <span className="mt-auto text-left text-grey-5 tl-body-xs m:tl-body-s">
        To take advantage of these savings at checkout, you must meet the{' '}
        <Clickable
          data-analytics-id="ev-card-read-more"
          data-qa="ev-card-read-more-pd"
          className="text-blue-2 tl-body-xs m:tl-body-s"
          onClick={() => setEvTaxCreditModalOpen(true)}
          element="span"
        >
          eligibility requirements.
        </Clickable>
      </span>
    </Card>
  );
};

export default CleanTaxSavingsCard;
